import React, { useState } from "react";
import { toast } from "react-hot-toast";
import { Spinner } from "../../../components/Spinner";
import { downloadServiceAgreementPdf } from "../../Onboarding/Kyc/TermsAndAgreement/LogisticsServicesAgreement";

const ServiceAgreementCard: React.FC = () => {
  const [isDownloading, setIsDownloading] = useState<boolean>(false);

  const handleDownloadServiceAgreement = async () => {
    if (isDownloading) return;

    try {
      setIsDownloading(true);
      await downloadServiceAgreementPdf();
      toast.success("Service agreement downloaded successfully.");
    } catch (error: any) {
      toast.error(error?.message || "Failed to download service agreement.");
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <div className="bg-white rounded-lg border border-[#E8E8E8] overflow-hidden mt-4 mb-4">
      <div className="flex items-center bg-[#F5F5F5] py-3 px-4 border-b border-[#E8E8E8]">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="mr-2 text-blue-600"
        >
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
          <polyline points="14 2 14 8 20 8"></polyline>
          <line x1="16" y1="13" x2="8" y2="13"></line>
          <line x1="16" y1="17" x2="8" y2="17"></line>
          <polyline points="10 9 9 9 8 9"></polyline>
        </svg>
        <h3 className="text-[#1C1C1C] font-semibold text-lg">
          Service Agreement
        </h3>
      </div>

      <div className="py-4 px-4 h-16 flex items-center justify-between hover:bg-gray-50">
        <div className="flex flex-col">
          <span className="text-gray-800 font-medium">Service Agreement</span>
          <span className="text-gray-500 text-sm">Available</span>
        </div>
        <button
          onClick={handleDownloadServiceAgreement}
          disabled={isDownloading}
          className={`text-gray-500 hover:text-blue-600 ${
            isDownloading ? "cursor-not-allowed opacity-60" : ""
          }`}
          title="Download Service Agreement"
        >
          {isDownloading ? (
            <Spinner className="h-5 w-auto" />
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
              <polyline points="7 10 12 15 17 10"></polyline>
              <line x1="12" y1="15" x2="12" y2="3"></line>
            </svg>
          )}
        </button>
      </div>
    </div>
  );
};

export default ServiceAgreementCard;
